// extracted by mini-css-extract-plugin
module.exports = {"toast":"PlayerToast_toast__7c8cs","icon":"PlayerToast_icon__sno5s","text":"PlayerToast_text__P3fBn"};